import React from 'react';

import Loadable from 'react-loadable';
import { useMemoOne } from 'use-memo-one';

import { AnalyticsErrorBoundary } from '@atlaskit/analytics-next';

import { failUfoExperience, UfoExperiences } from '../../ufo-experiences';
import type { ShareToSlackProps } from '../common/types';

import Loading from './Loading';

export default function LazyBulkShareToSlack(props: ShareToSlackProps): React.JSX.Element {
	const WrappedLoadable = useMemoOne(
		() =>
			Loadable<ShareToSlackProps, {}>({
				loader: () =>
					import(
						/* webpackChunkName: "@atlaskit-internal_share-to-slack-clone" */
						'./ShareToSlack'
					),
				loading: () => <Loading />,
			}),
		[],
	);

	return (
		<AnalyticsErrorBoundary
			onError={() => {
				failUfoExperience(UfoExperiences.SLACK_SEGMENT_RENDERED);
				failUfoExperience(UfoExperiences.SLACK_FORM_ENABLED);
			}}
			channel={'shareToSlack'}
			data={{}}
		>
			<WrappedLoadable {...props} />
		</AnalyticsErrorBoundary>
	);
}
